import { useSelector } from 'react-redux';

import {
  selectDevtoolsUserAuthToken,
  selectDevtoolsUserError,
  selectDevtoolsUserGroups,
} from '@lib/core/users/selectors/devtoolsUser';

export const useDevtoolsUser = () => {
  const devtoolsUserGroups = useSelector(selectDevtoolsUserGroups);
  const error = useSelector(selectDevtoolsUserError);
  const isDevtoolsUserAuthenticated = !!useSelector(selectDevtoolsUserAuthToken);
  const isDevtoolsUserLinkGenerator = devtoolsUserGroups?.some(userGroup => userGroup?.name === 'Link Generator');
  const isDevtoolsUserSensory = devtoolsUserGroups?.some(userGroup => userGroup?.name === 'Sensory');
  const isDevtoolsUserEditor = devtoolsUserGroups?.some(userGroup => userGroup?.name === 'Static Editor');
  const isDevtoolsUserWithPermission = devtoolsUserGroups?.some(userGroup => userGroup?.name === 'dev-panel');

  return {
    devtoolsUserGroups,
    error,
    isDevtoolsUserAuthenticated,
    isDevtoolsUserEditor,
    isDevtoolsUserLinkGenerator,
    isDevtoolsUserSensory,
    isDevtoolsUserWithPermission,
  };
};
